import React from "react";
import images from "../../../utilities/images/images";
import "./ExploringSpaceBrand.css";

const ExploringSpaceBrand = () => (
  <div className="exploring-space-brand" aria-label="Motion Exploring Space">
    <img
      src={images.motion_logo_new}
      alt="Motion"
      className="exploring-space-brand__logo"
    />
    <p className="exploring-space-brand__subtitle">EXPLORING SPACE</p>
  </div>
);

export default ExploringSpaceBrand;
